import { useQueries } from '@tanstack/react-query'

import { tenantSessionQueries } from '@/shared/auth/tenant-session'

import type { Tenant } from '@/shared/auth/types'

/**
 * Filters a tenant list down to those whose SKU permits SSO
 * (`sku_info.sso_allowed`).
 *
 * `allowed_tenants` carries only id/name, so each tenant's details are fetched
 * (cached 1h, shared with the Authentication route loader). A tenant is excluded
 * until its details resolve — the list must never offer a tenant the route would
 * immediately redirect away from.
 */
export const useSsoAllowedTenants = (tenants: Array<Tenant>): Array<Tenant> => {
	const results = useQueries({
		queries: tenants.map((tenant) => tenantSessionQueries.details(tenant.id)),
	})

	const allowedIds = new Set(
		results
			.filter((result) => result.data?.sku_info.sso_allowed)
			.map((result) => result.data!.id),
	)

	return tenants.filter((tenant) => allowedIds.has(tenant.id))
}
